import React from "react";
import paymentInProgress from "./payment-progress.svg";
import { FormattedMessage } from "react-intl";
import { isCurrentPath } from "../../helpers/pathUtils";
import { useSubdomain } from "../../hooks/useSubdomain";

export default function () {
  const { subdomain } = useSubdomain();

  return (
    <div className="in-progress-banner-mobile" id="in-progress-status">
      <img src={paymentInProgress} />
      <div className="banner-detials">
        <span className="banner-header">
          {isCurrentPath(["/m"], subdomain) ? (
            <FormattedMessage
              id="payment_in_progress_title_home"
              defaultMessage="Payment in progress"
            />
          ) : (
            <FormattedMessage
              id="payment_in_progress_title_others"
              defaultMessage="Another Payment is in progress"
            />
          )}
        </span>
        <span className="banner-text">
          {isCurrentPath(["/m"], subdomain) ? (
            <FormattedMessage
              id="payment_in_progress_text_home"
              defaultMessage="Please wait while we are currently trying to charge your card."
            />
          ) : (
            <FormattedMessage
              id="payment_in_progress_text_others"
              defaultMessage="Please wait while we complete the payment. If this you believe this is an error, please contact us."
            />
          )}
        </span>
      </div>
    </div>
  );
}
